export const groups = [
  {
    title: "Explore",
    links: [
      {
        title: "Sentinel Explorer",
        href: "https://explorer.sentinel.co",
      },
      {
        title: "Wallets",
        href: "https://docs.sentinel.co/getting-started/wallets",
      },
      {
        title: "Network Stats",
        href: "https://stats.sentinel.co/",
      },
      {
        title: "Node Dashboard",
        href: "https://nodes.sentinel.co/",
      },
      {
        title: "Node Map",
        href: "https://map.sentinel.co/",
      },
    ],
  },
  {
    title: "Learn",
    links: [
      {
        title: "Sentinel Whitepaper",
        href: "https://docs.sentinel.co/getting-started/whitepaper",
      },
      {
        title: "Cosmos Ecosystem",
        href: "https://cosmos.network/",
      },
      {
        title: "Docs",
        href: "https://docs.sentinel.co/",
      },
    ],
  },
  {
    title: "Apps",
    links: [
      {
        title: "Explore DVPN apps",
        href: "https://docs.sentinel.co/getting-started/apps",
      },
    ],
  },
];
